// Variables are set in .env
export const apiHost = process.env.LIFESUM_API_HOST
export const gaTrackingId = process.env.GOOGLE_ANALYTICS_ID
export const facebookLoginAppId = process.env.FACEBOOK_LOGIN_APP_ID
export const facebookTrackingAppId = process.env.FACEBOOK_TRACKING_APP_ID
export const adyenOriginKey = process.env.ADYEN_ORIGIN_KEY
export const environment = process.env.environment
export const appleRedirectUri = process.env.APPLE_REDIRECT_URI
export const datoToken = process.env.DATO_TOKEN
export const gaMeasurementId = process.env.GA_MEASUREMENT_ID
export const ga4MeasurementId = process.env.GA4_MEASUREMENT_ID
export const clientId = process.env.CLIENT_ID
export const clientSecret = process.env.CLIENT_SECRET
export const googleLoginId = process.env.GOOGLE_LOGIN_ID
